import { Label, Input, FormErrorMessage } from "@src/common/components";
import React, { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

interface ControllerInputProps {
  name: string;
  label: string;
  className?: string;
  inputType?: string;
  required?: boolean;
}

const ControllerInput: FC<ControllerInputProps> = ({
  name,
  label,
  className,
  inputType = "text",
  required = false,
}) => {
  const {
    control,
    formState: { errors, dirtyFields },
  } = useFormContext();

  const isTouched = dirtyFields[name];
  const hasError = !!errors[name];
  const isValid = isTouched && !hasError;

  return (
    <Controller
      control={control}
      name={name}
      rules={required ? { required: `${label} is required` } : undefined}
      render={({ field }) => (
        <div className={className}>
          <Label className="block text-xs font-medium text-gray-700 truncate">
            {label}{" "}
            {!required && (
              <span className="text-slate-400 text-xs">(Optional)</span>
            )}
          </Label>
          <Input
            size={"mini"}
            value={field.value}
            onChange={(event) => field.onChange(event.currentTarget.value)}
            onBlur={field.onBlur}
            type={inputType}
            error={hasError}
            positive={dirtyFields[name] && !hasError}
          />
          <span className="text-red-500 text-xs">
            <FormErrorMessage errors={errors} name={name} />
          </span>
        </div>
      )}
    />
  );
};

export default ControllerInput;
